import React from 'react';
import MetricSection from './MetricSection';
import SourceFooter from './SourceFooter';
import TimeSeriesChart from './TimeSeriesChart';
import { ChartPanel, datasetById, MetricCallout } from './SectionElements';

const CapabilitySection = ({ datasets, range, isZh = false }) => {
    const eci = datasetById(datasets, 'epoch_eci_frontier');
    const workloads = datasetById(datasets, 'capability_workloads');
    const metr = { ...workloads, series: workloads.series.filter((point) => point.metric === 'metr_time_horizon') };
    const swe = { ...workloads, series: workloads.series.filter((point) => point.metric === 'swe_bench_verified') };
    const latestEci = eci.series[eci.series.length - 1];
    const latestMetr = metr.series[metr.series.length - 1];
    const latestSwe = swe.series[swe.series.length - 1];
    const eciChange = ((latestEci.value / eci.series[0].value) - 1) * 100;

    return (
        <MetricSection
            id="capability"
            index={1}
            title="AI Capability Frontier"
            titleZh="AI 能力边界"
            summary="Track general capability and real-work task frontiers separately, without collapsing them into one opaque score."
            summaryZh="把综合能力、可持续任务时长和真实编码任务分别展示，不再压缩成一个不透明总分。"
            isZh={isZh}
        >
            <div className="ai-dev-callout-row">
                <MetricCallout value={latestEci.value.toFixed(1)} label="ECI frontier" note={`${latestEci.model} · ${latestEci.date}`} />
                <MetricCallout value={`+${eciChange.toFixed(1)}%`} label={isZh ? '相对首个可用点' : 'vs first usable point'} note="2023-02 → 2026-07" />
                <MetricCallout value={`${(latestMetr.value / 60).toFixed(1)}h`} label={isZh ? 'METR 任务时长' : 'METR task horizon'} note={`${latestMetr.model} · 50%`} />
                <MetricCallout value={`${latestSwe.value.toFixed(1)}%`} label="SWE-bench Verified" note={latestSwe.model} />
            </div>
            <ChartPanel
                eyebrow={isZh ? '综合能力前沿' : 'GENERAL CAPABILITY'}
                title={isZh ? 'Epoch ECI：跨基准的长期能力尺度' : 'Epoch ECI: a cross-benchmark long-run scale'}
                note={isZh ? '数值越高越强；不是百分比' : 'Higher is better; not a percentage'}
                className="ai-dev-panel--primary"
            >
                <TimeSeriesChart dataset={eci} range={range} ariaLabel="Epoch ECI capability frontier" valueFormatter={(value) => value.toFixed(0)} />
                <SourceFooter dataset={eci} isZh={isZh} />
            </ChartPanel>
            <div className="ai-dev-grid ai-dev-grid--2">
                <ChartPanel eyebrow="METR" title={isZh ? '50% 成功率任务时长（分钟）' : '50% task time horizon (minutes)'} note={isZh ? '含置信区间字段' : 'confidence intervals retained'}>
                    <TimeSeriesChart dataset={metr} range={range} ariaLabel="METR task horizon" scale="log" valueFormatter={(value) => value >= 60 ? `${(value / 60).toFixed(1)}h` : `${value.toFixed(0)}m`} />
                </ChartPanel>
                <ChartPanel eyebrow="SWE-BENCH VERIFIED" title={isZh ? '真实软件问题解决率' : 'Real software issue resolve rate'} note={isZh ? '独立坐标，不与 METR 合成' : 'separate scale'}>
                    <TimeSeriesChart dataset={swe} range={range} ariaLabel="SWE-bench Verified frontier" valueFormatter={(value) => `${value.toFixed(0)}%`} />
                </ChartPanel>
            </div>
            <SourceFooter dataset={workloads} isZh={isZh} />
        </MetricSection>
    );
};

export default CapabilitySection;
